"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";

const TabHelp = ({ t }) => {
  const pathname = usePathname();

  const tabs = [
    { href: "/faq", label: t?.["FAQs"] || "FAQs" },
    { href: "/legals", label: t?.["Legals"] || "Legals" },
    { href: "/privacy", label: t?.["Privacy Policy"] || "Privacy Policy" },
  ];

  return (
    <div className="tabContainer">
      {tabs.map((tab) => (
        <Link
          key={tab.href}
          href={tab.href}
          className={`tab ${pathname === tab.href ? "active" : ""}`}
        >
          {tab.label}
        </Link>
      ))}
    </div>
  );
};

export default TabHelp;
